import { useState } from "react"

interface DevShowPropProps {
   label: string
   text?: string
}

export function DevShowProp({ label, text }: DevShowPropProps) {
   const [copied, setCopied] = useState(false)
   const isDev = import.meta.env.DEV

   if (!isDev || !text) return null

   const handleCopy = async () => {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
   }

   return (
      <div className="flex items-center gap-2 text-sm text-gray-500">
         <span>{label}:</span>
         <span
            className="cursor-pointer hover:text-gray-700 transition-colors"
            onClick={handleCopy}
            title="Cliquer pour copier"
         >
            {text}
         </span>
         {copied && <span className="text-xs text-green-500">Copié !</span>}
      </div>
   )
}
